"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Breadcrumb = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _BreadcrumbItem = _interopRequireDefault(require("./BreadcrumbItem"));
var _commonUtils = require("@sial/common-utils");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    breadcrumbs: (0, _defineProperty2.default)({
      marginTop: theme.spacing(6),
      fontSize: theme.typography.pxToRem(12)
    }, theme.breakpoints.down('xs'), {
      '& a': {
        display: 'none'
      },
      '& a:last-child': {
        display: 'inline'
      },
      '& svg': {
        display: 'none',
        transform: 'rotate(180deg)'
      },
      '& svg:nth-last-child(2)': {
        display: 'inline-block'
      }
    }),
    breadcrumbItem: {
      fontSize: 'inherit'
    },
    arrow: {
      color: theme.palette.grey['500'],
      width: theme.typography.pxToRem(16),
      height: theme.typography.pxToRem(16),
      marginTop: theme.spacing(1),
      verticalAlign: 'top'
    }
  };
});
var breadcrumbEditConfig = {
  emptyLabel: 'Breadcrumbs - Page Path',
  isEmpty: function isEmpty(props) {
    if (typeof props.items !== 'undefined' && props.items.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var Breadcrumb = function Breadcrumb(_ref) {
  var items = _ref.items;
  var classes = useStyles();
  var breadcrumbs = items ? items : [];
  var hasMultipleBreadcrumbs = breadcrumbs.length > 1;
  var eventLabel = breadcrumbs.reduce(function (accumulator, currentValue) {
    var extra = accumulator ? ' > ' : '';
    return "".concat(accumulator).concat(extra).concat(currentValue.titleEng);
  }, '');
  var isGTMEnabled = function isGTMEnabled() {
    var _window;
    return typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.dataLayer);
  };
  var handleBreadcrumbClick = function handleBreadcrumbClick(action, linkUrl) {
    if (!isGTMEnabled) return;
    _commonUtils.Analytics.sendGTMEvent({
      eventType: _commonUtils.GTMEventTypes.AnalyticsEvent,
      payload: {
        event: 'navigation_interaction',
        action: 'breadcrumb click',
        detail: (eventLabel === null || eventLabel === void 0 ? void 0 : eventLabel.toLowerCase()) || undefined,
        section: undefined,
        component: 'breadcrumb',
        element_type: 'link',
        element_text: (action === null || action === void 0 ? void 0 : action.toLowerCase()) || undefined,
        link_url: linkUrl || undefined,
        core_event: 'no',
        user_detail: undefined,
        event_group: undefined,
        event_subgroup: undefined,
        eventCategory: _commonUtils.GTMEventCategory.Breadcrumbs.toLowerCase(),
        eventAction: (action === null || action === void 0 ? void 0 : action.toLowerCase()) || _commonUtils.EventValues.NotAvailable,
        eventLabel: (eventLabel === null || eventLabel === void 0 ? void 0 : eventLabel.toLowerCase()) || _commonUtils.EventValues.NotAvailable,
        eventInteractionType: 0
      }
    });
  };
  return __jsx("div", {
    className: classes.breadcrumbs
  }, breadcrumbs.map(function (breadcrumb, i) {
    return __jsx(_react.default.Fragment, {
      key: i
    }, i > 0 && hasMultipleBreadcrumbs && __jsx(_KeyboardArrowRight.default, {
      className: classes.arrow
    }), __jsx(_BreadcrumbItem.default, (0, _extends2.default)({}, breadcrumb, {
      handleBreadcrumbClick: handleBreadcrumbClick
    })));
  }));
};
exports.Breadcrumb = Breadcrumb;
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/breadcrumb')(Breadcrumb, breadcrumbEditConfig);
exports.default = _default;